import React from 'react';
import { useIntl } from 'react-intl';

import {
  WizardScreen,
  FooterMode
} from '@futrli/ui-components/components/sidebar/wizard/screens/wizard-screen/wizard-screen';
import { WizardFinished } from '@futrli/ui-components/components/sidebar/wizard/wizard-finished/wizard-finished';

export interface DriverCreatedWizardScreenProps {
  isUpdate?: boolean;
  onClose: () => void;
  onCreateAnother: () => void;
}

export const DriverCreatedWizardScreen = ({ isUpdate, onClose, onCreateAnother }: DriverCreatedWizardScreenProps) => {
  const intl = useIntl();

  const viewText = intl.formatMessage({
    id: 'predict.common.close',
    defaultMessage: 'Close'
  });
  const createAnotherText = intl.formatMessage({
    id: 'predict.non_financial_drivers.create_another',
    defaultMessage: 'Create another'
  });

  const text = (() => {
    if (isUpdate) {
      return intl.formatMessage({
        id: 'predict.non_financial_drivers.driver_updated_successfully',
        defaultMessage: 'Driver updated successfully'
      });
    }
    return intl.formatMessage({
      id: 'predict.non_financial_drivers.driver_created_successfully',
      defaultMessage: 'Driver created successfully'
    });
  })();

  return (
    <WizardScreen
      footerMode={FooterMode.CREATED}
      onCancel={onCreateAnother}
      closeText={createAnotherText}
      onView={onClose}
      viewText={viewText}
    >
      <WizardFinished text={text} />
    </WizardScreen>
  );
};
